import React from 'react';
import {
  Box,
  Heading,
  HStack,
  ModalHeader as ChakraModalHeader,
  Text,
} from '@chakra-ui/react';
import PadlockIcon from '../icons/PadlockIcon';

const ModalHeader = (props: {
  title: string;
  titlePrefix: string;
  content: string;
  upgradePrompt?: string;
}) => (
  <ChakraModalHeader pb={0} fontWeight="normal">
    {props.upgradePrompt && (
      <HStack mb={2}>
        <PadlockIcon colour="#DF6EBA" />
        <Text fontSize="md" color="#DF6EBA">
          {props.upgradePrompt}
        </Text>
      </HStack>
    )}

    <Text fontSize="xl">{props.titlePrefix}</Text>

    <Heading
      as="h2"
      fontFamily="body"
      fontSize="4xl"
      fontWeight="medium"
      mb={2}
    >
      {props.title}
    </Heading>

    <Text fontSize="md">{props.content}</Text>

    <Box
      mt="5"
      bgGradient="linear(to-r, #BE2E66, #EC8F40, #488542, #3B83D3)"
      h="5px"
      w="100%"
      borderRadius="md"
    />
  </ChakraModalHeader>
);

export default ModalHeader;
